// @flow

import { type Node } from 'react';
import { type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

type ValidationErrorMessageProps = {|
  validationError: ?UserInputValidationError,
|};

export function ValidationErrorMessage({ validationError }: ValidationErrorMessageProps): Node {
  const fallback = useInvalidErrorByCountry();

  if(!validationError) {
    return fallback;
  }

  if (validationError.id === 'server-error') {
    return serverErrorMessage(validationError.payload, fallback);
  }

  return fallback;
}


function useInvalidErrorByCountry(): string {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return 'Documento inválido';

    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
      return 'El número de documento que informaste no es válido.';

    default:
      throw new Error(`Field Customer Mail: ${country} has no Invalid Mail Error Message`);
  }
}
